



















import { PartnerPractice } from '@/shared/partner-practice';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class PartnerPracticesTable extends Vue {
    @Prop({ required: true }) private partnerPractices!: Array<PartnerPractice>;
    @Prop({ required: true }) private page!: number;
    @Prop({ required: true }) private pageSize!: number;
    @Prop({ required: true }) private total!: number;

    private currentPage: number = this.page;

    private get partnerPracticeFields(): Array<{}> {
        return [
            { key: 'name', label: 'Name' },
            { key: 'address', label: 'Address' },
            { key: 'email', label: 'Email' },
            { key: 'telephone', label: 'Telephone' },
            { key: 'status', label: 'Status' },
            { key: 'actions', label: '', class: 'col-1', tdClass: 'text-right' },
        ];
    }

    private get paginationDescription(): string {
        const start = this.partnerPractices.length < 1 ? 0 : ((this.currentPage - 1) * this.pageSize) + 1;
        const end = start + this.pageSize > this.total ? this.total : start + this.pageSize - 1;

        return `Showing ${start.toLocaleString()} - ${end.toLocaleString()} of ${this.total.toLocaleString()}`;
    }

    @Watch('page')
    private onPageChanged(page: number): void {
        this.currentPage = page;
    }

    @Watch('currentPage')
    private onCurrentPageChanged(): void {
        this.$emit('page-changed', this.currentPage);
    }
}
